import type { PropsWithChildren } from "react";

import { CompactCard } from "../../../common-ui/CompactCard";

interface IntermodalDetailsCardProps extends PropsWithChildren {}

export function IntermodalDetailsCard({
  children,
}: IntermodalDetailsCardProps) {
  return <CompactCard flex={1}>{children}</CompactCard>;
}
